<template>
    <div class="app-container">
        <el-table
        :data="subject_field"
        style="width: 100%"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
            <el-table-column
                prop="value"
                label="学科分类"
                >
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import {
  search_category,
} from "../../api/jounal.js";
export default {
    data(){
        return{
            subject_field:[],
            defaultProps: {
                children: 'subset',
                label: 'value'
            }
        }
    },
    created(){
        this.GetSearchCategory()
    },
    methods:{
        GetSearchCategory(){
            search_category().then(res=>{
                this.subject_field = this.handleTree(res.info_list[4].subject_field,'id')
            })
        },
        /**
         * 构造树型结构数据
         * @param {*} data 数据源
         * @param {*} id id字段 默认 'id'
         * @param {*} parent_id 父节点字段 默认 'parent_id'
         * @param {*} children 孩子节点字段 默认 'children'
         * @param {*} rootId 根Id 默认 0
         */
        handleTree(data, id = 'id', parent_id = 'parent_id', children = 'children', rootIds = [0, -1]) {
            //对源数据深度克隆
            const cloneData = JSON.parse(JSON.stringify(data))
            //循环所有项
            const treeData = cloneData.filter(node => {
            node[children] = cloneData.filter(child => {//筛选本项的下级
            return node[id] == child[parent_id]
            });
                for(let i in rootIds){
                if(node[parent_id] == rootIds[i]){
                    return true;
            }
            }
                return false;
            });
            return treeData != '' ? treeData : data;
        }
    }
}
</script>

<style>

</style>